import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ArrowRight, Home, Search } from 'lucide-react';
import { parseMarkdownItalics } from '../components/SafecareBrand';
import './ShockTherapy.css'; // Reusing shock therapy styles for cards

export default function NotFound() {
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('/data/shock_therapy_index.json')
            .then(res => res.json())
            .then(data => {
                if (data && data.series) {
                    // Flatten all articles from all series
                    const allArticles = data.series.flatMap(series => series.articles);

                    // Shuffle and pick 6
                    const shuffled = allArticles.sort(() => 0.5 - Math.random());
                    setSuggestions(shuffled.slice(0, 6));
                }
                setLoading(false);
            })
            .catch(err => {
                console.error("Failed to load shock therapy data", err);
                setLoading(false);
            });
    }, []);

    return (
        <div className="not-found-page" style={{ minHeight: '80vh', paddingTop: '100px', paddingBottom: '4rem' }}>
            <div className="container">
                <div style={{ textAlign: 'center', marginBottom: '4rem', maxWidth: '800px', margin: '0 auto 4rem auto' }}>
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5 }}
                    >
                        <h1 style={{
                            fontSize: 'clamp(4rem, 10vw, 8rem)',
                            fontWeight: '800',
                            background: 'linear-gradient(135deg, #ef4444 0%, #f97316 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            lineHeight: 1,
                            marginBottom: '1rem'
                        }}>
                            404
                        </h1>
                        <h2 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#fff' }}>
                            Page Not Found
                        </h2>
                        <p style={{ fontSize: '1.2rem', color: '#94a3b8', marginBottom: '2rem' }}>
                            It seems this page has fallen into a coverage gap. Unlike the current healthcare system, we won't leave you stranded.
                        </p>

                        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
                            <Link to="/" className="btn btn-primary glow-effect">
                                <Home size={20} /> Return Home
                            </Link>
                            <Link to="/search" className="btn btn-glass" style={{ display: 'none' }}>
                                <Search size={20} /> Search
                            </Link>
                        </div>
                    </motion.div>
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', color: '#64748b' }}>Loading suggestions...</div>
                ) : (
                    suggestions.length > 0 && (
                        <div className="shock-suggestions">
                            <h3 style={{
                                textAlign: 'center',
                                marginBottom: '2rem',
                                color: '#e2e8f0',
                                fontSize: '1.5rem'
                            }}>
                                While you're here, uncover <span style={{ color: '#2dd4bf' }}>6 truths</span> about the system:
                            </h3>

                            <div className="shock-articles-grid" style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                                gap: '2rem'
                            }}>
                                {suggestions.map((article) => (
                                    <Link to={`/shock-therapy/${article.id}`} key={article.id} className="shock-card" style={{ textDecoration: 'none' }}>
                                        <div className="shock-card-image" style={{ height: '160px' }}>
                                            <img src={article.image} alt={article.title} loading="lazy" style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                                            <div className="shock-card-overlay" />
                                        </div>
                                        <div className="shock-card-content" style={{ padding: '1.5rem' }}>
                                            <h4 style={{
                                                fontSize: '1.1rem',
                                                marginBottom: '0.5rem',
                                                color: '#fff',
                                                lineHeight: 1.4
                                            }}>
                                                {parseMarkdownItalics(article.title)}
                                            </h4>
                                            <span className="shock-read-btn" style={{ fontSize: '0.9rem', marginTop: 'auto' }}>
                                                Read File <ArrowRight size={14} />
                                            </span>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    )
                )}
            </div>
        </div>
    );
}
